/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Channel_SessionInputs */

const en_us2_push_channel_session = /** @type {(inputs: Push_Channel_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session summary`)
};

const pt_br2_push_channel_session = /** @type {(inputs: Push_Channel_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo do treino`)
};

const es_419_push_channel_session = /** @type {(inputs: Push_Channel_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen del entrenamiento`)
};

const pt_pt2_push_channel_session = /** @type {(inputs: Push_Channel_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo do treino`)
};

const fr_fr2_push_channel_session = /** @type {(inputs: Push_Channel_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résumé de séance`)
};

const de_de2_push_channel_session = /** @type {(inputs: Push_Channel_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingszusammenfassung`)
};

const it_it2_push_channel_session = /** @type {(inputs: Push_Channel_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riepilogo della sessione`)
};

/**
* | output |
* | --- |
* | "Session summary" |
*
* @param {Push_Channel_SessionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_channel_session = /** @type {((inputs?: Push_Channel_SessionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Channel_SessionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_channel_session(inputs)
	if (locale === "es-419") return es_419_push_channel_session(inputs)
	if (locale === "pt-PT") return pt_pt2_push_channel_session(inputs)
	if (locale === "fr-FR") return fr_fr2_push_channel_session(inputs)
	if (locale === "de-DE") return de_de2_push_channel_session(inputs)
	if (locale === "it-IT") return it_it2_push_channel_session(inputs)
	return en_us2_push_channel_session(inputs)
});
export { push_channel_session as "push.channel_session" }